import { AxiosError } from 'axios'
import { UseQueryOptions } from '@tanstack/react-query'

import { Queries } from 'api/queries.enum'
import { GetPulseSurveysResponse } from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { getPulseSurveys } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { preventRefetchQueryOptions } from 'utils/queryOptions'
import { useQuery } from 'hooks/useQuery'

export const useGetPulseSurveys = (options?: UseQueryOptions<GetPulseSurveysResponse, AxiosError>) => {
    return useQuery<GetPulseSurveysResponse, AxiosError>({
        queryKey: [Queries.getPulseSurveys],
        queryFn: getPulseSurveys,
        ...preventRefetchQueryOptions,
        ...options,
    })
}
